import { generateBindings, view, View } from '@esui/core';
import { spread } from '@esui/core/utils/spread.js';
import '@material/mwc-formfield';
import { Formfield as MdcFormfield } from '@material/mwc-formfield';
import { html } from 'lit';

export { MdcFormfield };

export const [Formfield] = view('esui-mwc-formfield', {
  Props: class {
    label = '';
    alignEnd = false;
    spaceBetween = false;
    nowrap = false;
    content?: View = undefined;
  },
  mapBuilder: FormfieldBuilder => (content: View) =>
    FormfieldBuilder().content(content),

  template(props) {
    const myBindings = generateBindings(props, ['content']);

    return html`
      <mwc-formfield ${spread({ ...myBindings })}>
        ${props.content?.body}
      </mwc-formfield>
    `;
  },
  noShadow: true,
});
